import { FilterBuilder } from '../Types';

export const studapartBuilder: FilterBuilder = (_, context) => {
  if (!context) return '';

  const { excludeStudapart } = context;

  return excludeStudapart ? 'advertiserId!=1579986' : '';
};
